'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const reactAria = require('react-aria');
const reactAriaComponents = require('react-aria-components');
const clsx = require('clsx');
const Description_Description = require('../Description/Description.cjs.js');
const ErrorMessage_ErrorMessage = require('../ErrorMessage/ErrorMessage.cjs.js');
const Label_Label = require('../Label/Label.cjs.js');
const Select_SelectGroup = require('./SelectGroup.cjs.js');
const Select_SelectItem = require('./SelectItem.cjs.js');
const designSystem = require('@zapier/design-system');
const Select_SelectContext = require('./SelectContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const select = "_select_y9j48_1";
const selectTrigger = "_select-trigger_y9j48_10";
const selectValue = "_select-value_y9j48_42";
const popover = "_popover_y9j48_59";
const listBox = "_list-box_y9j48_73";
const styles = {
	select: select,
	selectTrigger: selectTrigger,
	selectValue: selectValue,
	popover: popover,
	listBox: listBox
};

const Select = ({ "aria-describedby": ariaDescribedBy, "aria-details": ariaDetails, children, className, defaultSelectedValue, isDisabled = false, errorMessage, helpText, isInvalid = false, isLabelHidden = false, isOpen, isRequired = false, label, onBlur, onFocus, onFocusChange, onKeyDown, onKeyUp, onOpenChange, onValueChange, placeholder, selectedValue, size = "medium" }) => {
  const isSSR = reactAria.useIsSSR();
  const [disabledKeys, setDisabledKeys] = React.useState([]);
  const registerDisabledItem = React.useMemo(() => ({
    registerDisabledItem: (id) => {
      setDisabledKeys((prev) => [...prev, id]);
    }
  }), []);
  if (isSSR) {
    return null;
  }
  return React__default.default.createElement(
    Select_SelectContext.SelectContext.Provider,
    { value: registerDisabledItem },
    React__default.default.createElement(
      reactAriaComponents.Select,
      { "aria-details": ariaDetails, "aria-describedby": ariaDescribedBy, className: clsx.clsx(className, styles.select), "data-zds": true, defaultSelectedKey: defaultSelectedValue, disabledKeys, isDisabled, isInvalid, isOpen, onBlur, onFocus, onFocusChange, onKeyDown, onKeyUp, onOpenChange, onSelectionChange: onValueChange, placeholder, selectedKey: selectedValue, isRequired },
      isLabelHidden ? React__default.default.createElement(
        designSystem.VisuallyHidden,
        null,
        React__default.default.createElement(Label_Label.Label, null, label)
      ) : React__default.default.createElement(Label_Label.Label, { isCompact: size === "compact", isRequired, isDisabled, isInvalid }, label),
      React__default.default.createElement(
        reactAriaComponents.Button,
        { className: styles.selectTrigger, "data-size": size, "data-zds": true },
        React__default.default.createElement(reactAriaComponents.SelectValue, { "data-size": size, className: styles.selectValue, "data-zds": true }),
        React__default.default.createElement(designSystem.Icon, { name: "arrowDropdown", color: "TextWeaker", size: size === "compact" ? 20 : 24 })
      ),
      isInvalid && errorMessage ? React__default.default.createElement(ErrorMessage_ErrorMessage.ErrorMessage, { isCompact: size === "compact" }, errorMessage) : helpText && React__default.default.createElement(Description_Description.Description, { isCompact: size === "compact" }, helpText),
      React__default.default.createElement(
        reactAriaComponents.Popover,
        { className: styles.popover, style: {
          "--popover-shadow": designSystem.Shadows.elevation20
        }, "data-zds": true },
        React__default.default.createElement(reactAriaComponents.ListBox, { className: styles.listBox, "data-zds": true }, children)
      )
    )
  );
};
Select.Item = Select_SelectItem.SelectItem;
Select.Group = Select_SelectGroup.SelectGroup;

exports.Select = Select;
//# sourceMappingURL=Select.cjs.js.map
